export enum SidebarActivityType {
  DEFAULT = 'DEFAULT',
  VIZ = 'VIZ'
}